module.exports = __webpack_public_path__ + "img/FahradhelmProbe.23beb891.svg";